import { Icon } from '@iconify/react'
import { useNav } from '../../../hooks/useNav'
import TableData from '../../../components/ui/TableData'
import { PATH } from '../../../data/router_path'
import { Button } from '../../../components/ui/legacy'
import useGetGuestAccount from './hooks/useGetGuestAccount'
import { showErrorToast } from '../../../utils/showToast'
import { PAGE_SIZE } from '../../../data/queryFactories'
import ExportExcelAccountGuest from './components/ExportExcelAccountGuest'
import { RiDeleteBin6Line } from 'react-icons/ri'
import { accountService } from '../../../service/AccountService'
import ConfirmationBox from '../../../components/ui/ConfirmationBox'
import { useState } from 'react'
export default function AccountGuestDataTable() {
  const navigate = useNav()
  const [deleteAccountGuest, setDeleteAccountGuest] = useState(null)
  const {
    data: {
      pageNumber = 1,
      pageSize = PAGE_SIZE,
      users = [],
      totalItems = 0,
    } = {},
  } = useGetGuestAccount() // sau phai sua thanh account
  const columnMapping = [
    { key: 'id', value: 'Mã tài khoản' },
    { key: 'name', value: 'Tên tài khoản' },
    { key: 'joinDate', value: 'Ngày tạo' },
    { key: 'course', value: 'Khoá' },
    { key: 'groups', value: 'Nhóm' },
    { key: 'schoolEmail', value: 'Email trường' },
    { key: 'personalEmail', value: 'Email cá nhân' },
    { key: 'phoneNumber', value: 'Số điện thoại' },
  ]
  const columnWidths = {
    id: 'w-[8.33vw]',
    name: 'w-[15vw]',
    joinDate: 'w-[10vw]',
    course: 'w-[8.33vw]',
    groups: 'w-[10.83vw]',
    schoolEmail: 'w-[15vw]',
    personalEmail: 'w-[15vw]',
    phoneNumber: 'w-[10.83vw]',
    status: 'w-[8.33vw]',
    // books: 'w-[13.33vw]',
    // devices: 'w-[8.33vw]',
  }
  const actionButtons = [
    {
      title: 'Chỉnh sửa',
      icon: (
        <Icon
          icon="ph:pencil-simple-line"
          className={'text-2xl text-main-grey'}
        />
      ),
      onClick: (row) =>
        showErrorToast({
          message: 'Lỗi',
          error: 'Chức năng đang được phát triển',
        }),
    },
    {
      title: 'Xóa tài khoản khách',
      icon: <RiDeleteBin6Line className="text-2xl text-main-red" />,
      onClick: (row) => setDeleteAccountGuest(row),
      lable: 'Xóa tài khoản khách',
    },
  ]
  const detailDeleteFunction = async (row) => {
    try {
      const res = await accountService.deleteAccountGuest(row)
      if (res?.meta.code !== 200) {
        throw new Error(res?.meta.message)
      }
      navigate(PATH.ACCOUNT.GUEST.LIST)
      window.location.reload()
      setDeleteAccountGuest(null)
    } catch (error) {
      throw new Error(error)
    }
  }
  const detailViewFunction = (row) => {
    navigate(PATH.ACCOUNT.GUEST.DETAIL(row.uuid))
  }

  return (
    <>
      <TableData
        data={users}
        columnMapping={columnMapping}
        columnWidths={columnWidths}
        actionButtons={actionButtons}
        paginationEnabled={true}
        dataType="tài khoản"
        currentPage={pageNumber}
        totalPages={Math.ceil(totalItems / pageSize)}
        pageSize={pageSize}
        totalItems={totalItems}
        path={PATH.ACCOUNT.GUEST.LIST}
        detailView={detailViewFunction}
        extraFunctions={[
          <Button
            variant={'plain'}
            onClickHandler={() => navigate(PATH.ACCOUNT.GUEST.CREATE)}
          >
            Tạo tài khoản khách
          </Button>,
          <ExportExcelAccountGuest />,
        ]}
      />
      {deleteAccountGuest && (
        <ConfirmationBox
          title={
            <p className="font-bold text-red-500">
              Xác nhận xóa tài khoản khách? <br />
              (MSV: {deleteAccountGuest.id})
            </p>
          }
          message=" Thao tác này sẽ không thể hoàn tác!"
          onConfirm={() => detailDeleteFunction(deleteAccountGuest)}
          onCancel={() => setDeleteAccountGuest(null)}
        />
      )}
    </>
  )
}
